import _ from 'lodash'

import {
  SELECT,
  SET_SELECT,
  DESELECT,
  RESET,
  TOGGLE_SELECT,
  DESELECT_ALL,
  SET_ACTIVE,
  TOGGLE_ACTIVE,
  RESET_ACTIVE,

  SET_ASCENDANTS,
  SET_DESCENDANTS,
  SET_RELATED,
  RESET_RELATED
} from 'react-redux/actions/highlight'

import { RESET as APP_RESET } from 'react-redux/actions/app'

const initialState = {
  active: { domain:null, uid:null},
  selected: [],
  uid: null, // currently selected items uid as string
  descendants: { playlist:{}, asset:{}, mediaplayer:{}, surface: {} },
  ascendants: { playlist:{}, asset:{}, mediaplayer:{}, surface: {} }
}

const makeId = (domain, uid) => {
  return {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_RESET: {
      return _.cloneDeep(initialState)
    }
    case SELECT: {
      const { payload } = action
      const { domain, uid } = payload
      let selected = _.cloneDeep(state.selected)
      selected = _.without(selected, _.find(selected, {domain, uid}))
      selected.push({domain, uid})
      return Object.assign({}, state, { selected })
    }
    case SET_SELECT: {
      const { payload } = action
      const { domain, uid } = payload
      return Object.assign({}, state, { selected: [{domain, uid}] })
    }
    case DESELECT: {
      const { payload } = action
      const { domain, uid } = payload
      let selected = _.cloneDeep(state.selected)
      selected = _.without(selected, _.find(selected, {domain, uid}))
      return Object.assign({}, state, { selected })
    }
    case TOGGLE_SELECT: {
      const { payload } = action
      const { domain, uid } = payload
      let selected = _.cloneDeep(state.selected)
      const found = _.find(selected, {domain, uid})
      if (found) {
        selected = _.without(selected, found)
      } else {
        selected.push({domain, uid})
      }
      return Object.assign({}, state, { selected })
    }
    case DESELECT_ALL: {
      return Object.assign({}, state, { selected: [] })
    }
    case SET_ACTIVE: {
      const { payload } = action
      const { domain, uid } = payload
      return Object.assign({}, state, { active: { domain, uid } })
    }
    case TOGGLE_ACTIVE: {
      const { payload } = action
      const { domain, uid } = payload
      if (state.active.domain === domain && state.active.uid === uid) {
        return Object.assign({}, state, { active: { domain: null, uid: null } })
      }
      return Object.assign({}, state, { active: { domain, uid } })
    }
    case RESET_ACTIVE: {
      return Object.assign({}, state, { active: { domain: null, uid: null } })
    }
    case RESET: {
      return Object.assign({}, _.cloneDeep(initialState))
    }
    case SET_ASCENDANTS: {
      return Object.assign({}, state, { ascendants: action.ascendants })
    }
    case SET_DESCENDANTS: {
      return Object.assign({}, state, { descendants: action.descendants })
    }
    case SET_RELATED: {
      return Object.assign(
        {},
        state,
        {
          ascendants: action.ascendants,
          descendants: action.descendants
        }
      )
    }
    case RESET_RELATED: {
      return Object.assign(
        {},
        state,
        {
          descendants: initialState.descendants,
          ascendants: initialState.ascendants
        }
      )
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/react-redux/reducers/highlight.js